"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuidV7 = exports.uuid = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.uuid = typebox_1.Type.String({
    format: 'uuid',
    minLength: 36,
    maxLength: 36,
    description: 'Identifier in the UUID format'
});
exports.uuidV7 = typebox_1.Type.String({
    format: 'uuid',
    minLength: 36,
    maxLength: 36,
    description: 'Identifier in the UUIDv7 format (time-sortable). Read more https://uuid7.com'
});
//# sourceMappingURL=uuid.js.map